// extracted by mini-css-extract-plugin
export default {"layout":"Pill_layout__ieja+","badge":"Pill_badge__7ihDw","label":"Pill_label__VsPSH","invisiblelabel":"Pill_invisiblelabel__WxhBY"};